export default __webpack_public_path__ + "static/media/nub.40e46e65.png";